export default "﻿<div>\n    Offene Verträge\n    <div data-dojo-attach-point=\"tableContainer\">${translations.General__NoEntries}</div>\n\n</div>\n"